import { render, staticRenderFns } from "./typingDuplicate.vue?vue&type=template&id=4bcd8353&scoped=true&"
import script from "./typingDuplicate.vue?vue&type=script&lang=js&"
export * from "./typingDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./typingDuplicate.vue?vue&type=style&index=0&id=4bcd8353&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd8353",
  null
  
)

export default component.exports